export interface Category {
  slug: string;
  name: string;
  icon: string;
  description: string;
}

export const categories: Category[] = [
  { slug: "platform-entry", name: "平台入口", icon: "ri-links-line", description: "官方入口与最新地址汇总" },
  { slug: "register-login", name: "注册登录", icon: "ri-user-add-line", description: "账号注册与登录指南" },
  { slug: "tutorials", name: "使用教程", icon: "ri-book-open-line", description: "详细操作教程与技巧" },
  { slug: "features", name: "功能解析", icon: "ri-apps-2-line", description: "核心功能详细介绍" },
  { slug: "news", name: "最新资讯", icon: "ri-newspaper-line", description: "平台动态与公告" },
  { slug: "faq", name: "常见问题", icon: "ri-question-answer-line", description: "热门问题解答汇总" },
];